import { useBrandPricingSupplierQuery } from 'api';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';

export const useMainSupplier = () => {
  const [mainSupplierRemoveModalState, setMainSupplierRemoveModalState] = useState<boolean>(false);
  const [priceReferenceSupplierModalState, setPriceReferenceSupplierModalState] = useState<boolean>(false);
  const [priceReferenceSupplierRemoveModalState, setPriceReferenceSupplierRemoveModalState] = useState<boolean>(false);

  const { id } = useParams() as { id: string };
  const { data = {} } = useBrandPricingSupplierQuery({ brandId: id });
  const navigate = useNavigate();

  const onRedirectToSupplier = useCallback(
    (id: string) => navigate(`${ADMIN_ROUTES.suppliers.view}/${id}/general`),
    [navigate]
  );
  const onMainRemoveModalStateChange = useCallback(() => {
    setMainSupplierRemoveModalState((prevState) => !prevState);
  }, []);
  const onPriceReferenceSupplierModalStateChange = useCallback(() => {
    setPriceReferenceSupplierModalState((prevState) => !prevState);
  }, []);
  const onPriceReferenceSupplierRemoveModalStateChange = useCallback(() => {
    setPriceReferenceSupplierRemoveModalState((prevState) => !prevState);
  }, []);
  return {
    mainSupplier: data?.mainSupplier,
    pricingReferenceSupplier: data?.pricingReferenceSupplier,
    mainSupplierRemoveModalState,
    onMainRemoveModalStateChange,
    priceReferenceSupplierModalState,
    onPriceReferenceSupplierModalStateChange,
    onPriceReferenceSupplierRemoveModalStateChange,
    priceReferenceSupplierRemoveModalState,
    onRedirectToSupplier,
  };
};
